module.exports = __webpack_public_path__ + "img/anchor_input.6b02153a.png";